import Validation from 'utils/validation.utils';
import locale from 'localization';

export const initialState = (state = {}) => {
  const {
    firstName = {
      value: '',
      disabled: false
    },
    lastName = {
      value: '',
      disabled: false
    },
    username = {
      value: '',
      disabled: false
    },
    role = {
      value: '',
      disabled: false
    },
    password = {
      value: '',
      disabled: false
    }
  } = state;
  return {
    firstName: {
      name: 'firstName',
      placeholder: locale.enterFirstName,
      validations: [Validation.required({ noMessage: true }), Validation.name()],
      maxLength: 75,
      label: locale.firstName,
      required: true,
      ...firstName
    },
    lastName: {
      name: 'lastName',
      placeholder: locale.enterLastName,
      validations: [Validation.required({ noMessage: true }), Validation.name()],
      maxLength: 75,
      label: locale.lastName,
      required: true,
      ...lastName
    },
    username: {
      name: 'username',
      placeholder: locale.enterUsername,
      validations: [Validation.required({ noMessage: true })],
      maxLength: 75,
      label: locale.username,
      required: true,
      ...username
    },
    password: {
      name: 'password',
      placeholder: locale.enterPassword,
      validations: [Validation.required({ noMessage: true })],
      maxLength: 75,
      label: locale.password,
      required: true,
      ...password
    },
    role: {
      name: 'role',
      placeholder: locale.enterRole,
      label: locale.role,
      required: true,
      ...role
    }
  };
};
